import React, { FC } from "react";

import { Col, Row } from "react-bootstrap";

import classNames from "classnames";
import { ReactSVG } from "react-svg";

import { CheckCircleSolidIcon, CircleHollowIcon, CircleWithSolidCentreIcon } from "@assets/icons";

import styles from "./BreadCrumbs.module.scss";

export interface BreadcrumbStep {
  name: string;
  subtitle?: string;
  showCurrentStepCompleted?: boolean;
}

interface BreadCrumbsProps {
  steps: BreadcrumbStep[];
  currentStepIndex: number;
  orientation?: "horizontal" | "vertical";
}

export const BreadCrumbs: FC<BreadCrumbsProps> = ({ steps, currentStepIndex, orientation = "horizontal" }) => {
  const breadcrumbs = steps.map((step, i) => {
    const isLast = i === steps.length - 1;
    const isCurrentStep = i === currentStepIndex;
    const isPending = i > currentStepIndex;
    const icon = isPending
      ? CircleHollowIcon
      : isCurrentStep && !step.showCurrentStepCompleted
        ? CircleWithSolidCentreIcon
        : CheckCircleSolidIcon;

    const horizontalStep = (
      <>
        <ReactSVG className={classNames(styles["icon"])} src={icon} />
        <div>{step.name}</div>
        {!isLast && <div className={styles["divider"]}></div>}
      </>
    );

    const verticalStep = (
      <>
        <div className="d-inline-flex align-items-center">
          <ReactSVG className={classNames(styles["icon"])} src={icon} />
          <div className={classNames(styles["step-text"], "b3")}>
            {step.name}
            {step.subtitle && <div className={classNames(styles["subtitle"], "b4")}>{step.subtitle}</div>}
          </div>
        </div>
        {!isLast && <div className={styles["divider"]}></div>}
      </>
    );

    return (
      <div
        className={classNames(styles["multistep-breadcrumb"], "d-flex align-items-center", {
          [styles["current-step"]]: isCurrentStep,
          [styles["completed"]]: !isCurrentStep && !isPending,
          [styles["pending"]]: isPending,
          [styles["active"]]: !isPending,
          [styles[orientation]]: true,
        })}
        key={step.name}
      >
        {orientation === "horizontal" ? horizontalStep : verticalStep}
      </div>
    );
  });

  return (
    <Row className={classNames(styles["breadcrumb-row"], styles[orientation], "justify-content-center", "z-2")}>
      <Col
        xs={12}
        className={classNames("d-flex", {
          "flex-column": orientation === "vertical",
          "justify-content-center align-items-center": orientation === "horizontal",
        })}
      >
        {breadcrumbs}
      </Col>
    </Row>
  );
};
